import { ImageText } from "../../ImageText";
import { StyleOfText } from "../../../common/textStyle";

export class NumberBox {
  private label: ImageText;
  private frame: PIXI.Sprite;
  private parentContainer: PIXI.Container;

  private valueStyle: PIXI.TextStyle;
  private currencyStyle: PIXI.TextStyle;
  // private jackpotStyle: PIXI.TextStyle;
  private value: PIXI.Text;
  private currency: PIXI.Text;
  private tweenIN: PIXI.tween.Tween;
  private tweenOut: PIXI.tween.Tween;
  private boxIndex: number;
  private stars: Array<PIXI.Sprite>;
  private starsTween: Array<PIXI.tween.Tween>;
  private starsTweenOut: Array<PIXI.tween.Tween>;
  private onFocus: boolean;
  private gameTextStyle: StyleOfText;

  constructor(
    boxValue: number,
    boxCurrency: string,
    label: string,
    index: number
  ) {
    this.parentContainer = new PIXI.Container();
    this.gameTextStyle = new StyleOfText();
    this.valueStyle = new PIXI.TextStyle({
      fontFamily: this.gameTextStyle.gameFont,
      fontSize: 50,
      //   fontWeight: "bold",
      fill: ["#ffffff"],
    });
    this.currencyStyle = new PIXI.TextStyle({
      fontFamily: this.gameTextStyle.gameFont,
      fontSize: 30,
      fill: ["#b98a58", "#b98a58", "#ffc880"],
      fontWeight: "bold",
    });
    // this.jackpotStyle= new PIXI.TextStyle({fontFamily: "Tahoma, Helvetica, sans-serif",fontSize: 50,fill: [ '#b98a58','#b98a58','#ffc880']  ,fontWeight:"bold"});

    this.frame = new PIXI.Sprite(
      PIXI.Texture.fromImage("jackpotSmallDisplayTextFrame.png")
    );
    this.value = new PIXI.Text(boxValue.toFixed(2), this.valueStyle);
    this.currency = new PIXI.Text(boxCurrency, this.currencyStyle);

    this.frame.anchor.set(0.5);
    this.frame.x = this.frame.width / 2;
    this.label = new ImageText(label, this.frame);
    let labelP = this.label.getParent();
    labelP.scale.set(0.25);
    labelP.cacheAsBitmap = true;
    // this.label=new PIXI.Sprite(labelSprite);
    this.frame.addChild(this.value);
    this.frame.addChild(this.currency);
    // this.frame.addChild(this.label);

    //animated stars
    this.stars = [];
    for (let i = 0; i < 6; i++) {
      this.stars[i] = new PIXI.Sprite(PIXI.Texture.fromFrame("star.png"));
      this.frame.addChild(this.stars[i]);
      // this.stars[i].scale.set(0.35);

      this.stars[i].width = 60;
      this.stars[i].height = this.stars[i].width;
      this.stars[i].anchor.set(0.5);
      if (i < 3) {
        this.stars[i].x = -this.frame.width / 2;
      } else {
        this.stars[i].x = this.frame.width / 2;
      }
    }
    // this.stars[0].scale.set(.25);
    // this.stars[1].scale.set(.25);

    this.stars[0].height = 40;
    this.stars[0].width = this.stars[0].height;
    this.stars[1].height = this.stars[0].width;
    this.stars[1].width = this.stars[0].height;

    this.stars[0].y = 50;
    this.stars[1].y = -50;
    this.stars[2].x = -this.frame.width / 2 - 30;
    if (this.stars.length >= 6) {
      // this.stars[3].scale.set(.25);
      // this.stars[4].scale.set(.25);

      this.stars[3].height = this.stars[0].height;
      this.stars[3].width = this.stars[0].height;
      this.stars[4].width = this.stars[0].width;
      this.stars[4].height = this.stars[0].height;
      this.stars[3].y = 50;
      this.stars[4].y = -50;
      this.stars[5].x = this.frame.width / 2 + 30;
    }

    this.onFocus = true;

    this.tweenIN = PIXI.tweenManager.createTween(this.frame);
    this.tweenOut = PIXI.tweenManager.createTween(this.frame);
    this.boxIndex = index;
    this.createTween();
    this.parentContainer.addChild(this.frame);
  }

  private createTween = (): void => {
    this.frame.alpha = 0;
    this.tweenIN
      .from({ alpha: 0, x: this.frame.x - 50 })
      .to({ alpha: 1, x: this.frame.x });
    this.tweenIN.time = 2500;
    this.tweenIN.delay = 200 * this.boxIndex;
    this.tweenIN.easing = PIXI.tween.Easing.outElastic();
    // console.log(this.boxIndex)

    this.tweenOut
      .from({ alpha: 1, x: this.frame.x })
      .to({ alpha: 0, x: this.frame.x - 50 });
    this.tweenOut.time = 2500;
    this.tweenOut.delay = 0;
    this.tweenOut.easing = PIXI.tween.Easing.outBack();

    this.starsTween = [];
    for (let i = 0; i < this.stars.length; i++) {
      this.starsTween[i] = PIXI.tweenManager.createTween(this.stars[i]);
      if (i < 3) {
        this.starsTween[i]
          .from({ alpha: 0, x: this.stars[i].x - 50 })
          .to({ alpha: 1, x: this.stars[i].x });
        this.starsTween[i].delay = 250 * i;
      } else {
        this.starsTween[i]
          .from({ alpha: 0, x: this.stars[i].x + 50 })
          .to({ alpha: 1, x: this.stars[i].x });
        this.starsTween[i].delay = 250 * (i - 3);
      }

      this.starsTween[i].time = 1500;

      this.starsTween[i].easing = PIXI.tween.Easing.outBack();
      // console.log(i, this.starsTween[i].delay)
    }

    this.starsTweenOut = [];
    for (let i = 0; i < this.stars.length; i++) {
      this.starsTweenOut[i] = PIXI.tweenManager.createTween(this.stars[i]);

      if (i < 3) {
        this.starsTweenOut[i]
          .from({ alpha: 1, x: this.stars[i].x })
          .to({ alpha: 0, x: this.stars[i].x - 50 });
        // this.starsTweenOut[i].delay =i*250;
        this.starsTweenOut[i].delay = 0;
      } else {
        this.starsTweenOut[i]
          .from({ alpha: 1, x: this.stars[i].x })
          .to({ alpha: 0, x: this.stars[i].x + 50 });
        // this.starsTweenOut[i].delay =(i-3)*250;
        this.starsTweenOut[i].delay = 0;
      }
      this.starsTweenOut[i].time = 1;

      this.starsTweenOut[i].easing = PIXI.tween.Easing.inBack();
    }
  };

  private disableStar = (): void => {
    if (this.onFocus == true) {
      for (let i = 0; i < this.stars.length; i++) {
        this.starsTween[i].stop();
        this.starsTweenOut[i].reset();
        this.starsTweenOut[i].start();
      }
      this.onFocus = false;
    }
  };
  private placing = (): void => {
    this.currency.x = 30 - this.frame.width / 2;
    this.currency.y =
      this.frame.height - this.currency.height - 5 - this.frame.height / 2;
    this.value.anchor.set(1);
    this.value.x = this.frame.width - 50 - this.frame.width / 2;
    this.value.y = 80 - this.frame.height / 2;

    // this.label.x=this.label.width
    let labelP = this.label.getParent();
    labelP.x = -labelP.width / 2 + 40;
    labelP.y = -this.frame.height; //-labelP.height
  };
  public startInAnimation = (): void => {
    this.frame.alpha = 0;
    this.tweenIN.reset();
    this.tweenIN.start();
  };

  public stop() {
    this.frame.alpha = 0;
    this.tweenIN.stop();
    this.tweenOut.stop();
  }

  public startOutAnimation = (): void => {
    this.frame.alpha = 1;
    this.tweenOut.reset();
    this.tweenOut.start();
  };

  // public setAlpha=(alphaVlaue:number):void=>
  // {
  //     this.parentContainer.alpha=alphaVlaue;
  // }

  public setMobileAnimationDuration = (): void => {
    for (let i = 0; i < this.starsTweenOut.length; i++) {
      this.starsTweenOut[i].time = 1;
      this.starsTweenOut[i].delay = 0;
      this.starsTween[i].time = 1;
      this.starsTween[i].delay = 0;
    }
    this.tweenIN.time = 1;
    this.tweenIN.delay = 0;
    this.tweenOut.time = 1;
    this.tweenOut.delay = 0;
  };

  public setPosition = (posX: number, posY: number): void => {
    // this.parentContainer.posX
    this.parentContainer.x = posX;
    this.parentContainer.y = posY;
  };

  public setParent = (parent: PIXI.Container): void => {
    parent.addChild(this.parentContainer);
    this.placing();
  };

  public setBoxHighlight = (bool: boolean): void => {
    if (bool) {
      this.parentContainer.alpha = 1;

      if (this.onFocus == false) {
        for (let i = 0; i < this.stars.length; i++) {
          this.starsTweenOut[i].stop();
          this.starsTween[i].reset();
          this.starsTween[i].start();
        }
        this.onFocus = true;
      }
    } else if (bool == false) {
      this.parentContainer.alpha = 0.4;

      this.disableStar();
    }
  };

  public setCurrency = (currency: string): void => {
    this.currency.text = currency;
    this.placing();
  };
  public setValue = (value: number | string): void => {
    if (typeof value == "number") {
      this.value.style.fontWeight = "bold";
      this.value.style.fill = "0xffffff";
      this.value.text = value.toFixed(2);
    } else {
      this.value.style.fontWeight = "normal";
      this.value.style.fill = "0xff0000";
      this.value.text = value;
    }

    this.placing();
    // console.log(this.boxIndex, " write", value);
  };
}
